(() => {
  'use strict';
  const element = document.getElementById('pjnz-garment-offer-config');
  if (!element || window.pjnzGarmentExperimentInstalled) return;
  const config = JSON.parse(element.textContent);
  const now = Date.now();
  const start = Date.parse(config.startAt), end = Date.parse(config.endAt);
  const hasEnd = config.endAt !== null && config.endAt !== undefined;
  if (!config.preview && (!config.enabled || !Number.isFinite(start) || now < start || (hasEnd && (!Number.isFinite(end) || now >= end)))) return;
  window.pjnzGarmentExperimentInstalled = true;
  const assignmentKey = 'pjnz-family-offer-20261005-v3-preview';
  const nativeFetch = window.fetch.bind(window);
  let cart = null;
  let refreshTimer;
  let checkoutPending = false;
  let revision = 0;
  const panel = document.getElementById('ab-review');
  const validGroup = value => value === 'control' || value === 'treatment';
  function storedGroup() {
    try { const value = localStorage.getItem(assignmentKey); if (validGroup(value)) return value; } catch (error) {}
    const cookie = document.cookie.split('; ').find(value => value.startsWith(assignmentKey + '='));
    return cookie ? decodeURIComponent(cookie.slice(assignmentKey.length + 1)) : null;
  }
  let group = panel && panel.getAttribute('data-review-group') || storedGroup();
  if (!validGroup(group)) group = crypto.getRandomValues(new Uint8Array(1))[0] < 128 ? 'control' : 'treatment';
  function persist() {
    try { localStorage.setItem(assignmentKey, group); } catch (error) {}
    document.cookie = assignmentKey + '=' + group + '; Max-Age=2419200; Path=/; SameSite=Lax; Secure';
  }
  persist();
  const root = config.cartUrl.replace(/cart\/?$/, '');
  const cartEndpoint = config.cartUrl + '.js';
  const updateEndpoint = config.cartUrl + '/update.js';
  const checkoutUrl = root + 'checkout';
  const money = cents => 'NZ$' + (cents / 100).toFixed(2);
  const treatment = () => group === 'treatment' && config.currency === 'NZD' && (!cart || cart.currency === 'NZD');
  function eligibleSpend(currentCart) {
    return (currentCart.items || []).reduce((total, item) => {
      const amount = Number(item.original_line_price);
      return Number.isFinite(amount) && amount >= 0 ? total + amount : total;
    }, 0);
  }
  function progressText(spend) {
    if (spend < config.tiers[0].minimumCents) return config.strings.cartRemaining.replace('__AMOUNT__', money(config.tiers[0].minimumCents - spend));
    if (spend < config.tiers[1].minimumCents) return config.strings.cartNextTier.replace('__AMOUNT__', money(config.tiers[1].minimumCents - spend));
    return config.strings.cartUnlocked;
  }
  const setText = (node, text) => { if (node.textContent !== text) node.textContent = text; };
  function setMessage(node, text) {
    const headline = node.matches('[data-pjnz-offer-banner], [data-pjnz-offer-product]');
    let main = node.querySelector('[data-pjnz-offer-main]');
    if (!main) {
      node.textContent = '';
      main = document.createElement('span');
      main.setAttribute('data-pjnz-offer-main', '');
      node.appendChild(main);
      let detailsTarget = node;
      if (headline) {
        const disclosure = document.createElement('details');
        disclosure.className = 'pjnz-offer-disclosure';
        const summary = document.createElement('summary');
        summary.textContent = 'Details';
        disclosure.appendChild(summary);
        node.appendChild(disclosure);
        detailsTarget = disclosure;
      }
      const conditions = document.createElement('small');
      conditions.className = 'pjnz-offer-details';
      conditions.setAttribute('data-pjnz-offer-conditions', '');
      detailsTarget.appendChild(conditions);
      const preview = document.createElement('small');
      preview.className = 'pjnz-offer-preview-note';
      preview.setAttribute('data-pjnz-offer-preview', '');
      detailsTarget.appendChild(preview);
    }
    setText(main, text);
    setText(node.querySelector('[data-pjnz-offer-conditions]'), headline ? config.strings.headlineConditions : config.strings.conditions);
    const preview = node.querySelector('[data-pjnz-offer-preview]');
    preview.hidden = !config.preview;
    setText(preview, config.preview ? config.strings.previewLabel : '');
  }
  function notice(selector, target, kind) {
    let node = document.querySelector(selector);
    if (!node && target) {
      node = document.createElement('div');
      node.className = 'pjnz-offer-message pjnz-offer-message--' + kind;
      node.setAttribute('data-pjnz-offer-' + kind, '');
      node.setAttribute('aria-live', 'polite');
      target.prepend(node);
    }
    return node;
  }
  function render() {
    const show = treatment();
    const banner = document.querySelector('[data-pjnz-offer-banner]');
    if (banner) { banner.hidden = !show; setMessage(banner, config.strings.banner); }
    const product = notice('[data-pjnz-offer-product]', show && document.querySelector('.product-form'), 'product');
    const message = notice('[data-pjnz-offer-cart]', show && document.querySelector('.checkout-subtotal-container__right'), 'cart');
    const usable = show && cart && Array.isArray(cart.items);
    const spend = usable ? eligibleSpend(cart) : 0;
    if (product) { product.hidden = !show; setMessage(product, config.strings.product); }
    const added = notice('[data-pjnz-offer-added]', show && document.querySelector('#cart-summary-overlay .cart-summary-overlay__actions'), 'added');
    if (added) { added.hidden = !show; setMessage(added, usable ? progressText(spend) : config.strings.product); }
    if (message) {
      message.hidden = !usable;
      if (usable) {
        setMessage(message, progressText(spend));
        message.dataset.thresholdMet = spend >= config.tiers[0].minimumCents ? 'true' : 'false';
      }
    }

  }
  async function json(url, options) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await nativeFetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
      if (!response.ok) throw new Error('Cart request failed');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function attributes() {
    return { pjnz_garment_experiment: config.experimentId, pjnz_garment_variant: group, pjnz_garment_offer: group === 'treatment' ? 'all_merchandise_15_at139_25_at229' : 'control' };
  }
  async function tag(current) {
    const values = attributes();
    if (!current.item_count || Object.keys(values).every(key => current.attributes && current.attributes[key] === values[key])) return current;
    return json(updateEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: values }) });
  }
  async function refresh() {
    const currentRevision = ++revision;
    try {
      const next = await tag(await json(cartEndpoint, { headers: { Accept: 'application/json' } }));
      if (currentRevision === revision) { cart = next; render(); }
    } catch (error) { if (currentRevision === revision) { cart = null; render(); } }
  }
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, 150); }
  function impression() {
    if (config.preview || !config.analyticsEnabled) return;
    const key = config.experimentId + ':' + group;
    try { if (sessionStorage.getItem(key)) return; } catch (error) {}
    const data = { experiment_id: config.experimentId, experiment_variant: group };
    if (typeof window.gtag === 'function') { window.gtag('set', 'user_properties', data); window.gtag('event', 'experiment_impression', data); }
    else { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'experiment_impression', ...data }); }
    try { sessionStorage.setItem(key, '1'); } catch (error) {}
  }
  function restoreError() {
    checkoutPending = false;
    const target = document.querySelector('.checkout-subtotal-container__right') || document.querySelector('#cart-summary-overlay .cart-summary-overlay__actions') || document.querySelector('.product-form');
    const node = notice('[data-pjnz-offer-error]', target, 'error');
    if (node) { node.hidden = false; setText(node, config.strings.error); }
  }
  async function route(event, form, destination) {
    if (event.defaultPrevented || checkoutPending) { if (checkoutPending) event.preventDefault(); return; }
    event.preventDefault();
    checkoutPending = true;
    ++revision;
    try {
      let next;
      if (form) {
        const values = new FormData(form);
        values.delete('checkout'); values.delete('update');
        Object.entries(attributes()).forEach(([key, value]) => values.set('attributes[' + key + ']', value));
        next = await json(updateEndpoint, { method: 'POST', headers: { Accept: 'application/json' }, body: values });
      } else next = await tag(await json(cartEndpoint, { headers: { Accept: 'application/json' } }));
      cart = next; render();
      const target = new URL(destination || checkoutUrl, location.origin);
      if (treatment()) {
        const codes = (target.searchParams.get('discount') || '').split(',').filter(Boolean);
        config.discountCodes.forEach(code => { if (!codes.includes(code)) codes.push(code); });
        target.searchParams.set('discount', codes.join(','));
      }
      window.location.assign(target.href);
    } catch (error) { restoreError(); }
  }
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === checkoutUrl.replace(/\/$/, '')) route(event, null, url.href);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.id !== 'cartform' || !event.submitter || event.submitter.name !== 'checkout') return;
    if (event.submitter.hasAttribute('formaction') || form.querySelector('[name="discount"]')) return;
    route(event, form, checkoutUrl);
  });
  document.addEventListener('change', event => {
    if (event.target.id === 'ab-review-group' && validGroup(event.target.value)) {
      group = event.target.value; persist(); render(); scheduleRefresh();
    }
  });
  window.fetch = function (input, options) {
    return nativeFetch(input, options).then(response => {
      const url = typeof input === 'string' ? input : input && input.url || String(input);
      if (response.ok && /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) scheduleRefresh();
      return response;
    });
  };
  if (window.jQuery) {
    jQuery(document).on('ajaxSuccess.pjnzGarment', (event, xhr, options) => {
      if (/\/cart\/(?:add|change|update)(?:\.js)?(?:\?|$)/.test(options.url || '')) scheduleRefresh();
    });
  }
  ['cart:updated', 'cart:refresh'].forEach(name => document.addEventListener(name, scheduleRefresh));
  window.addEventListener('pageshow', scheduleRefresh);
  new MutationObserver(records => {
    let opened = false;
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.id === 'cart-summary-overlay' || node.querySelector('#cart-summary-overlay'))) opened = true;
    }));
    render();
    if (opened) scheduleRefresh();
  }).observe(document.body, { childList: true, subtree: true });
  render(); impression(); refresh();
})();
